import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-login-fail',
  templateUrl: './login-fail.component.html',
  styleUrls: ['./login-fail.component.scss']
})
export class LoginFailComponent implements OnInit {

  constructor( ) { }

  ngOnInit() {
  }

}

